import { Card } from 'react-bootstrap';
import React from 'react';
import { ICreatorTypes } from '../../../../../../model/briefing/step1/ICreatorTypes';
import { CustomImageHandler } from '../../../../../../shared/components/CustomImageHandler';
import { priceSplitter } from '../../../../../../utils/helpers/priceSplitter';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../../store/rootReducer';

interface ICampaignTypeCardProps {
    item: ICreatorTypes;
    classes?: string;
}

export const CampaignTypeCard = ({ item, classes }: ICampaignTypeCardProps) => {
    const { locale } = useSelector((state: IAllStates) => state.auth.user);
    const isGerman = locale === 'de';
    return (
        <Card
            className={`create-campaign-card mb-2 mb-md-0 ${
                item?.isSelected ? 'box-shadow-primary border-primary' : ''
            } ${classes ?? ''}`}
        >
            <div>
                <CustomImageHandler photoPath={item?.creatorTypeImage?.thumbnail} altTag="Creator type background" />
            </div>
            <div className="p-3">
                <div className="d-flex justify-content-between">
                    <h5 className="font-weight-bold">{item?.title}</h5>
                    <h6 className="text-primary mb-0">
                        {priceSplitter(item?.followersRangeFrom)} - {priceSplitter(item?.followersRangeTo)}
                    </h6>
                </div>
                <span className="text-muted">{isGerman ? item?.descriptionGerman : item?.description}</span>
            </div>
        </Card>
    );
};
